import React from "react";
import styles from "./styles.scss";

class Table extends React.Component {
  render() {
    const {  title, children, onSearchChange } = this.props
    return (
      <div className={styles.container}>
        <div className={styles.header}>
          <h2> {title} </h2>
          {onSearchChange &&
          <input 
          className={styles.inputField}
          onChange={onSearchChange}
          placeholder="Sök..." />
          }
        </div>
        <table>{children}</table>
      </div>
    );
  }
}

export default Table;



// WEBPACK FOOTER //
// src/components/Table/index.jsx